import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceScreenSetting',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    serviceContentsId: String
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'contentsScreenId',
        'screenName',
        'screenConfigName',
        'isHomeScreen',
        // 'isReleased',
        'detailButton',
        'deleteButton',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          contentsScreenId: '画面ID',
          screenName: '画面名',
          screenConfigName: ' 画面構成名',
          isHomeScreen: 'ホーム画面設定',
          isReleased: '公開設定',
          detailButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          contentsScreenId: '',
          screenName: '',
          screenConfigName: '',
          isHomeScreen: '',
          isReleased: '',
          detailButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'contentsScreenId',
          'screenName',
          'screenConfigName',
          'isHomeScreen',
          'isReleased'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName,

      // model
      screenModel: state => state.serviceScreenSetting.screenModel,

      // form
      values: state => state.serviceScreenSetting.values,

      // modal
      updatedList: state => state.serviceContentsRegistScreenModal.updated,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      getValue: 'serviceScreenSetting/getValue'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  watch: {
    updatedList: function (to) {
      // モーダルで対象配信タイプの変更がされたら一覧を更新
      this.init()
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceScreenSetting/loadModel',
      showServiceContentsRegistScreenModal: 'serviceContentsRegistScreenModal/show',
    }),

    init () {
      this.loading = true

      //
      let screenSettingParams = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId
      }

      // データ読出し
      this.loadModel({
        screenSettingParams: screenSettingParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'screenName':
          return value || '未設定'
        case 'isHomeScreen':
          return Utility.getConstantsLabel(['ScreenSetting', 'HomeScreen'], value)
        case 'isReleased':
          return Utility.getConstantsLabel(['ScreenSetting', 'Released'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'ServiceScreenSettingForm',
        params: {
          serviceId: this.serviceId,
          serviceContentsId: this.serviceContentsId,
          contentsScreenId: props.row.contentsScreenUuid
        }
      })
    },

    deleteItem (props) {
      this.deleteTargetId = props.row.contentsScreenUuid
      // confirm
      const id = Utility.getObjectArrayValue(this.screenModel, 'contentsScreenUuid', this.deleteTargetId, 'contentsScreenId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
      // const serviceScreenParams = {
      //   serviceUuid: this.serviceId,
      //   serviceContentsUuid: this.serviceContentsId,
      //   ContentsScreenUuid: props.row.contentsScreenUuid,
      // }
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId,
        ContentsScreenUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsScreenDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + 'の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    showAddModal () {
      this.showServiceContentsRegistScreenModal({
        serviceId: this.serviceId,
        serviceContentsId: this.serviceContentsId,
        deviceTypeId: this.values.deviceTypeUuid
      })
    }
  }
}